import React, { Fragment } from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import { Section, Rows } from '@/components/layout'
import { Text } from '@/components/common'
import neatLogo from '@/assets/neat-competitor/neat-logo.png'

import styles from './NeatVsCompetitorComparisonTable.module.scss'

const NeatVsCompetitorComparisonTable = ({ comparisons, competitorLogo }) => (
  <>
    {comparisons.length > 0 && (
      <Section className={styles.comparison} paddingBottom={24}>
        <Rows className={styles.comparisonWrap}>
          <div className={styles.comparisonGrid}>
            <div className={styles.compareRowTitle} />

            <div className={styles.compareNeat}>
              <Image alt="Neat" src={neatLogo} />
            </div>

            <div className={styles.compareCompetitor}>
              <Image alt="Neat" src={competitorLogo} />
            </div>
            {comparisons.map(comparison => (
              <Fragment key={comparison.rowTitle}>
                <div className={styles.compareRowTitle}>
                  <Text.H3 className={styles.title}>{comparison.rowTitle}</Text.H3>
                </div>

                <div className={styles.compareNeat}>
                  <div className={styles.content}>
                    <Rows>
                      {comparison.neatText ?? ''}
                      {comparison.neatList && (
                        <ul>
                          {comparison.neatList.map((listItem) => (
                            <li key={listItem}>{listItem}</li>
                          ))}
                        </ul>
                      )}
                    </Rows>
                  </div>
                </div>

                <div className={styles.compareCompetitor}>
                  <Rows>
                    {comparison.competitorText ?? ''}
                    {comparison.competitorList && (
                      <ul>
                        {comparison.competitorList.map((listItem) => (
                          <li key={listItem}>{listItem}</li>
                        ))}
                      </ul>
                    )}
                  </Rows>
                </div>
              </Fragment>
            ))}
          </div>
        </Rows>
      </Section>
    )}
  </>
)

NeatVsCompetitorComparisonTable.propTypes = {
  competitorLogo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  comparisons: PropTypes.arrayOf(PropTypes.shape({
    feature: PropTypes.string,
    neatText: PropTypes.string,
    neatList: PropTypes.arrayOf(PropTypes.string),
    competitorText: PropTypes.string,
    competitorList: PropTypes.arrayOf(PropTypes.string),
  })),
}

export default NeatVsCompetitorComparisonTable
